var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c(
          "div",
          {
            staticClass: "modal-container modal-container-40",
            on: { mousedown: _vm.dontClose },
          },
          [
            _c(
              "div",
              {
                staticClass: "modal-body m-0",
                staticStyle: { "overflow-y": "auto" },
                style: { maxHeight: _vm.getMaxHeightClient() + "px" },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { margin: "0px 20px 0px 20px" },
                    attrs: { slot: "formcontent" },
                    slot: "formcontent",
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c("b-col", { staticStyle: { "text-align": "end" } }, [
                          _c("i", {
                            staticClass: "fa fa-times close-button",
                            staticStyle: { "font-size": "20px" },
                            on: { click: _vm.handleMouseDown },
                          }),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      { staticClass: "panel-heading" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "formTitleBlock",
                            attrs: { cols: "12" },
                          },
                          [
                            _c(
                              "h4",
                              {
                                staticClass: "content-block labelAccordionForm",
                              },
                              [
                                _c("i", {
                                  staticClass: "fa-light fa-file-code mr-2",
                                  staticStyle: { "font-size": "20px" },
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("common.payment_reject")) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-row",
                      [
                        _c("b-col", { attrs: { cols: "12" } }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.reasonLabel,
                                expression: "reasonLabel",
                              },
                            ],
                            staticClass: "commentTextArea border-0 p-0",
                            attrs: {
                              maxlength: "105",
                              isMandatory: "",
                              placeholder: _vm.$t(
                                "requestToPay.additionnal_inf_rjct"
                              ),
                            },
                            domProps: { value: _vm.reasonLabel },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.reasonLabel = $event.target.value
                              },
                            },
                          }),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "b-col",
                  {
                    staticClass: "p-0 m-0",
                    attrs: { cols: "6", sm: "4", md: "3", lg: "3", xl: "3" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary" },
                        on: { click: _vm.rejectPayment },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.rvk_label")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }